import { render } from "./manage_entity_type.html?vue&type=template&id=4336f758&external"
import script from "./manage_entity_type.js?vue&type=script&lang=js&external"
export * from "./manage_entity_type.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__